import React from 'react';
import css from './quizDesign.module.css';
import { CheckIcon, ArrowIcon } from './QuizIcons';
import { useTranslation } from 'react-i18next';

const QuizCompletion = ({ score, totalQuestions, onContinue, onReview }) => {
  const { t } = useTranslation();
  const percentage = Math.round((score / totalQuestions) * 100);

  return (
    <div className={css.doneWrapShow}>
      <div className={css.doneIcon}>
        <CheckIcon strokeWidth={2.5} style={{ width: 32, height: 32 }} />
      </div>
      <div className={css.doneH}>{t('Quiz completed!')}</div>
      <div className={css.doneP}>{t('Great job! You checked your understanding of the video.')}</div>
      <div className={css.doneScores}>
        <div className={css.doneS}>
          <div className={css.doneV}>{score}/{totalQuestions}</div>
          <div className={css.doneL}>{t('Score')}</div>
        </div>
        <div className={css.doneS}>
          <div className={css.doneV}>{percentage}%</div>
          <div className={css.doneL}>{t('Result')}</div>
        </div>
      </div>
      <div className={css.doneBtns}>
        <button className={css.qBtnAct} onClick={onContinue}>
          {t('Continue to Speaking')}
          <ArrowIcon style={{ width: 16, height: 16 }} />
        </button>
        <button className={css.doneBtn2} onClick={onReview}>
          {t('Review answers')}
        </button>
      </div>
    </div>
  );
};

export default QuizCompletion;
